import { useNavigate } from 'react-router-dom';
import { ArrowLeft, PenLine, Plug } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Composer } from '../components/mail/Composer';
import { useMailboxes } from '../hooks/useMailboxes';
import { Button, Card, EmptyState, IconButton, Page, PageHeader, Skeleton, SkeletonLines } from '../components/ui';

export function ComposePage() {
  const navigate = useNavigate();
  const mbs = useMailboxes();
  return (
    <Page>
      <div className="mx-auto max-w-3xl">
        <PageHeader
          icon={<PenLine className="h-5 w-5" />}
          title="New message"
          description="Drafts autosave on this device and to your account, so you can continue on another device."
          actions={<IconButton label="Back" variant="secondary" icon={<ArrowLeft className="h-[18px] w-[18px]" />} onClick={() => navigate(-1)} />}
        />
        {mbs.isPending ? (
          <Card className="space-y-4 p-6" aria-busy="true" aria-label="Loading mailboxes">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-4 w-1/2" />
            <SkeletonLines lines={5} className="pt-4" />
          </Card>
        ) : (mbs.data?.mailboxes.length ?? 0) === 0 ? (
          <Card>
            <EmptyState
              icon={<Plug className="h-6 w-6" />}
              title="Connect a mailbox to send email"
              description="MailPilot sends through your own Gmail, Outlook or IMAP account."
              actions={
                <Link to="/settings/accounts">
                  <Button variant="primary" icon={<Plug className="h-4 w-4" />}>Connect an account</Button>
                </Link>
              }
            />
          </Card>
        ) : (
          <Composer mode="new" onSent={() => navigate('/sent')} />
        )}
      </div>
    </Page>
  );
}
